<template>
  <div id="wrap">
    <b-container id="contents" class="my-5" fluid>
      <section>
        <b-row id="profile" align-h="center" class="mb-0">
          <b-col sm="12" md="8" class="px-0">
            <b-card :style="profileCardStyleObject" no-body>
              <b-card-body class="d-flex align-items-center">
                <!--                <SHIcons id="logo" name="logo" iconColor="#F5D021" width="100%" height="100%" stroke-width="1" stroke-color="#ffffff"/>-->
                <b-container fluid>
                  <b-row align-h="center" align-v="center">
                    <b-col class="profile-col p-3" sm="12" md="8">
                      <div class="d-flex justify-content-center justify-content-sm-start align-items-center mb-3">
                        <SHIcons v-if="!pfIcoDataURL" class="profile-icon" name="parson" width="100%" height="100%" />
                        <b-img
                          v-else
                          :src="pfIcoDataURL"
                          class="profile-icon mr-3 border"
                          width="100%"
                          height="100%"
                          rounded="circle"
                          style="object-fit: cover"
                          alt="Circle image"
                        ></b-img>
                        <b-card-title class="my-0">{{ display_name }}</b-card-title>
                      </div>
                      <div class="d-flex">
                        <div v-if="profileList.address_prefecture" class="mr-2">
                          <SHIcons name="gps" width="16" height="16" iconColor="#a2afc1" />
                          {{ profileList.address_prefecture }}
                        </div>
                        <div v-if="profileList.birth_year_month" class="d-flex">
                          <SHIcons name="birth" width="16" height="16" iconColor="#a2afc1" />
                          {{ profileList.birth_year_month }}
                        </div>
                      </div>
                    </b-col>
                  </b-row>
                </b-container>
              </b-card-body>
            </b-card>
          </b-col>
        </b-row>
      </section>
      <section>
        <b-row v-if="introduction" id="introduction" align-h="center">
          <b-col sm="12" md="8" class="portofolio-label py-3">
            <b-card>
              <b-card-text>
                <ElementAutoLink :text="introduction"></ElementAutoLink>
              </b-card-text>
            </b-card>
          </b-col>
        </b-row>
      </section>
      <section>
        <b-row id="works-label" align-h="center" v-if="achievementList.length">
          <b-col sm="12" md="8" class="portofolio-label py-3">Works</b-col>
        </b-row>
        <b-row id="works" align-h="center" class="mb-3" v-if="achievementList.length">
          <b-col sm="12" md="8">
            <b-card v-for="item in achievementList" :key="item.achievement_id">
              <b-card-title class="d-flex align-items-center">
                <h4 class="works-title">{{ item.title }}</h4>
                <h4 v-if="item.issued_at" class="portofolio-works-issued">({{ arrangedDate(item.issued_at) }})</h4>
              </b-card-title>
              <b-card-text class="portofolio-works-detail" v-if="item.detail">{{ item.detail }}</b-card-text>
              <div v-if="item.link">
                <SHIcons name="link" width="16" height="16" iconColor="#a2afc1" />
                <b-link class="card-link portofolio-works-link" :href="sanitizeUrl(item.link)" target="_blank">
                  {{ item.link }}
                </b-link>
              </div>
              <b-container class="mt-2 portofolio-works-files" v-if="item.files.length" fluid>
                <b-row v-for="(file, index) in item.files" :key="index">
                  <b-col sm="12" class="text-left px-0">
                    <SHIcons name="dictionary" width="16" height="16" iconColor="#a2afc1" />
                    <b-link class="card-link portofolio-works-file" @click="downloadFile(file.id)">
                      {{ file.file_name }}
                    </b-link>
                  </b-col>
                </b-row>
              </b-container>
            </b-card>
          </b-col>
        </b-row>
      </section>
      <section>
        <b-row id="career-label" align-h="center" v-if="careerList.length">
          <b-col sm="12" md="8" class="portofolio-label py-3">Career</b-col>
        </b-row>
        <b-row id="career" align-h="center" class="mb-3" v-if="careerList.length">
          <b-col sm="12" md="8">
            <b-card v-for="(item, index) in careerList" :key="index">
              <b-card-title class="d-flex justify-content-between mb-0">
                <b-container fluid>
                  <b-row>
                    <b-col sm="8" md="8" class="portofolio-career-name pl-0 d-flex align-items-center">
                      <h5 class="mb-0">{{ item.name }}</h5>
                      <div class="portofolio-career-line ml-3"></div>
                    </b-col>
                    <b-col sm="4" md="4" class="text-left d-flex align-items-center">
                      <div class="portofolio-career-date" v-if="item.started_at">
                        {{ item.started_at }}
                      </div>
                      <div class="portofolio-career-date px-1">-</div>
                      <div class="portofolio-career-date" v-if="item.ended_at">
                        {{ item.ended_at }}
                      </div>
                    </b-col>
                  </b-row>
                </b-container>
              </b-card-title>
              <b-card-text class="portofolio-career-position">{{ item.position }}</b-card-text>
            </b-card>
          </b-col>
        </b-row>
      </section>
    </b-container>
  </div>
</template>

<script>
import SHIcons from '@/components/ico/SHIcons.vue'
import ElementAutoLink from '@/components/presentationals/ElementAutoLink.vue'
import { sanitizeUrl } from '@braintree/sanitize-url'
import { getArrangedDate } from '@/transformer/datespan'
import { getURLFromBase64 } from '@/transformer/file'

export default {
  name: 'PortofolioView',
  components: {
    SHIcons,
    ElementAutoLink
  },
  mounted() {
    this.$nextTick(function () {
      if (this.$route.hash.match(/^#/)) {
        document.getElementById(this.$route.hash.replace(/^#/, '')).scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        })
      }
    })
  },
  watch: {
    $route: (to, from) => {
      if (to.hash.match(/^#/)) {
        document.getElementById(to.hash.replace(/^#/, '')).scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        })
      }
    }
  },
  props: {
    list: Object,
    careers: Array,
    prefectures: Array,
    career_types: Array,
    pfIcoDataURL: String,
    pfBgDataURL: String
  },
  data() {
    return {
      profileCardStyleObject: {
        minHeight: this.pfBgDataURL ? '25vh' : 'unset',
        background: `url(${this.pfBgDataURL})`,
        backgroundSize: 'contain',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        borderRadius: 0,
        color: '#ffffff'
      }
    }
  },
  computed: {
    display_name: function () {
      return this.list.display_name
    },
    profileList: function () {
      let tmp = ''
      let tmp2 = ''
      let tmp3 = ''
      let tmp4 = ''
      if (!this.list.profiles.address_prefecture) {
        tmp = '' // 「表示しない」
      } else if (!this.prefectures[this.list.profiles.address_prefecture]) {
        tmp = '' // プロフィールが「未登録」なので表示しない
      } else {
        tmp = this.prefectures[this.list.profiles.address_prefecture]
      }
      if (!this.list.profiles.birth_year) {
        tmp2 = '' // 「表示しない」
      } else if (this.list.profiles.birth_year === '0') {
        tmp2 = '' // プロフィールが未設定なので表示しない
      } else {
        tmp2 = this.list.profiles.birth_year
      }
      if (!this.list.profiles.birth_month) {
        tmp3 = '' // 「表示しない」
      } else if (this.list.profiles.birth_month === '0') {
        tmp3 = '' // プロフィールが未設定なので表示しない
      } else {
        tmp3 = this.list.profiles.birth_month
      }

      if (tmp2) {
        if (tmp3) {
          tmp4 = tmp2 + '年' + tmp3 + '月'
        } else {
          tmp4 = tmp2 + '年'
        }
      } else {
        if (tmp3) {
          tmp4 = tmp3 + '月'
        } else {
          tmp4 = ''
        }
      }

      // 未登録は画面に表示しない仕様変更
      tmp = tmp === '未登録' ? '' : tmp

      const profileList = {
        address_prefecture: tmp,
        birth_year_month: tmp4
      }

      return profileList
    },
    introduction: function () {
      return this.list.introduction
    },
    achievementList: function () {
      return this.list.achievements
    },
    careerList: function () {
      const careerList = this.careers.map((e) => {
        return {
          name: e.name,
          position: e.position,
          started_at: getArrangedDate(e.started_at),
          ended_at: getArrangedDate(e.ended_at)
        }
      })
      return careerList
    }
  },
  methods: {
    arrangedDate($date) {
      return getArrangedDate($date)
    },
    downloadFile: function (achievementFileId) {
      // ダウンロード処理サンプルコード、後で移動する
      this.$axios
        .get(
          this.$constList.apiUrl +
            'view/download_file?achievement_file_id=' +
            achievementFileId +
            '&portofolio_id=' +
            this.list.portofolio_id
        )
        .then((res) => {
          const url = getURLFromBase64(res.data.mime_type, res.data.base64)

          const downloadLink = document.createElement('a')
          downloadLink.download = res.data.file_name
          downloadLink.href = url
          downloadLink.dataset.downloadurl = [res.data.mime_type, res.data.file_name, downloadLink.href].join(':')
          downloadLink.click()
        })
        .catch((err) => {
          // エラー時の処理
          console.log(err)
        })
    },
    sanitizeUrl: function (work) {
      return sanitizeUrl(work)
    }
  }
}
</script>

<style>
@media print {
  /* 添付ファイルを非表示にする */
  #works .portofolio-works-files {
    display: none;
  }

  /* ページ全体の左右の余白を削る */
  section > .row > .col-md-8 {
    width: 100%;
    max-width: 100%;
    flex-basis: 100%;
  }
}
</style>

<style scoped>
.card {
  border: 0;
}
.card,
.card * {
  break-inside: avoid;
  page-break-inside: avoid;
}

/* 改行を有効にする */
.card-text {
  font-size: 1rem;
  color: #464646;
  white-space: pre-wrap;
}

/* ラベル */
.portofolio-label {
  font-size: 1.4rem;
  text-decoration: none;
  color: #33537e;
}

#contents {
  margin-top: 0 !important;
  counter-reset: works-number 0 career-number 0;
}

#logo {
  width: 50px;
  height: 50px;
  position: absolute;
  top: 2vmax;
  left: 2vmax;
  z-index: 10;
}

/* PROFILE */

#profile .card-title {
  font-weight: bold;
}
#profile .profile-icon {
  width: 8vmax;
  max-width: 80px;
  height: 8vmax;
  max-height: 80px;
}
#profile .profile-col {
  backdrop-filter: blur(3px);
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.3);
}

/* WORKS */

/* 成果日付 */
#works .portofolio-works-issued {
  font-size: 1rem;
}
#works .works-title:before {
  counter-increment: works-number 1;
  content: counter(works-number) '.\00a0';
}
#works .card:first-child:not(:only-child) {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  border-bottom: dotted 2px;
}
#works .card:nth-child(n + 2):not(:last-child) {
  border-radius: 0;
  border-top: none;
  border-bottom: dotted 2px;
}
#works .card:last-child:not(:only-child) {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  border-top: none;
}
#works .portofolio-works-link {
  text-decoration: underline;
  color: #33537e;
}
#works .portofolio-works-file {
  color: #33537e;
}

/* CAREER */

#career .card:first-child:not(:only-child) {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  border-bottom: none;
}
#career .card:nth-child(n + 2):not(:last-child) {
  border-radius: 0;
  border-top: none;
  border-bottom: none;
}
#career .card:last-child:not(:only-child) {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  border-top: none;
}
#career .card:not(:only-child):not(:last-child) .card-body {
  padding-bottom: 0;
}
#career .portofolio-career-name:before {
  counter-increment: career-number 1;
  content: counter(career-number) '.\00a0';
}
#career .portofolio-career-line {
  height: 1px;
  flex: 1;
  background: #33537e;
}
#career .portofolio-career-date {
  font-size: 0.95rem;
}
#career .portofolio-career-position {
  font-size: 0.95rem;
}
</style>
